import { atom, useAtom } from 'jotai';
export const paymentAmountAtom = atom(0);
export const usePaymentAmountAtom = () => useAtom(paymentAmountAtom);
